import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationQuestionsKey,
  deleteJobPostingsQuestionsRoute,
  errorMessage,
} from '@features/applicationQuestions';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type UseDeleteApplicationQuestionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteApplicationQuestion = ({
  setErrorText = () => {},
}: UseDeleteApplicationQuestionProps) => {
  const client = useQueryClient();

  const {
    mutate: deleteApplicationQuestion,
    isLoading: isDeleteApplicationQuestionLoading,
  } = useMutation({
    mutationFn: (variables: { question_id: number }) =>
      axiosInstance
        .post(deleteJobPostingsQuestionsRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        client.invalidateQueries([applicationQuestionsKey]);
         client.invalidateQueries([profileKey]);
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return { deleteApplicationQuestion, isDeleteApplicationQuestionLoading };
};
